import { createContext, useContext } from 'react';
import {
  type NavigateOptions,
  type To,
  useNavigate,
} from 'react-router';

export type NavigationGuard = {
  hasChanges: boolean;
  saveChanges: () => boolean | Promise<boolean>;
  discardChanges: () => void | Promise<void>;
};

export type NavigationGuardChange = (guard: NavigationGuard | null) => void;

export type NavigationGuardContextValue = {
  setNavigationGuard: NavigationGuardChange;
  guardedNavigate: (to: To, options?: NavigateOptions) => void;
};

export const NavigationGuardContext = createContext<NavigationGuardContextValue | null>(null);

export const useNavigationGuard = () => {
  const context = useContext(NavigationGuardContext);
  if (!context) {
    throw new Error(
      'useNavigationGuard must be used within a NavigationGuardProvider',
    );
  }
  return context;
};

export const useGuardedNavigate = () => {
  const context = useContext(NavigationGuardContext);
  const navigate = useNavigate();

  return context?.guardedNavigate ?? navigate;
};
